module.exports = __webpack_public_path__ + "img/2.db8c7db9.jpg";